export default "__VITE_ASSET__CnEFqzkT__"